import {
  EmployeeBucketFormRule,
  EmployeeBucketFormSchema,
} from "@core/form/form.rule";
import { zodResolver } from "@hookform/resolvers/zod";
import "./offboard-employee-bucket.scss";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import FormEmployeeBucketOffboard from "../form-employee-bucket-offboard/form-employee-bucket";
import { Button } from "primereact/button";
import { GetEmployeeBucketModel } from "@core/model/query-model-employee-bucket";
import { useFormDefaultEmployeeBucket } from "@core/form/form-default-employee-bucket.hook";
import { useQyOffboardEmployeeBucket } from "@core/query/employee-bucket.query";
import { confirmDialog } from "primereact/confirmdialog";

export interface OffboardEmployeeBucketProps {
  bucket?: GetEmployeeBucketModel;
}
export function OffboardEmployeeBucket({
  bucket,
}: OffboardEmployeeBucketProps) {
  const { showSuccess } = useNotificationContext();
  const { getDefault } = useFormDefaultEmployeeBucket();
  const { mapOffboardEmployeeBucket } = useFormApiMapper();
  const { showError } = useNotificationContext();

  // API OFFBOARD Person
  const handleOffboardApiSuccess = () => {
    showSuccess("Employee offboard successfully");
  };
  const { mutate: offboard } = useQyOffboardEmployeeBucket(
    handleOffboardApiSuccess
  );

  // LOCAL
  const formMethod = useForm<EmployeeBucketFormSchema>({
    defaultValues: getDefault(bucket),
    resolver: zodResolver(EmployeeBucketFormRule),
  });
  const { handleSubmit } = formMethod;

  const terminate = (form: any, code: string) => {
    const formData = mapOffboardEmployeeBucket(form, form.code);
    offboard(formData);
  };
  const handleValidate = (form: EmployeeBucketFormSchema) => {
    const formCode = form.code;
    if (!formCode) {
      return;
    }

    confirmDialog({
      message: "Are you sure you want to terminate employee?",
      header: "Terminate Confirmation",
      icon: "pi pi-info-circle",
      defaultFocus: "reject",
      acceptClassName: "p-button-danger",
      accept() {
        terminate(form, formCode);
      },
    });
  };
  const handleValidateError = (err: FieldErrors<EmployeeBucketFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="OffboardEmployeeBucket" className="offboard-employee-bucket">
      <h2>Offboard Form</h2>
      <FormProvider {...formMethod}>
        <section className="grid grid-cols-1 mb-4 bg-white">
          <FormEmployeeBucketOffboard />
        </section>
      </FormProvider>
      <Button
        className="w-full block"
        label="Offboard"
        onClick={handleSubmit(handleValidate, handleValidateError)}
      ></Button>
    </div>
  );
}

export default OffboardEmployeeBucket;
